import React, {useState, useEffect, Suspense} from 'react';
import './App.less';
import {Switch, Route, Link} from "react-router-dom"

import {Layout, Avatar, Dropdown, Menu, Badge, Button, Popover, Space} from 'antd';
import {DownOutlined, BellOutlined} from '@ant-design/icons';
import {connect} from 'react-redux'
// import avatar from './img/avatar.png'
// import wechatImg from "./img/wechat.png"
// import qrcodeImg from "./img/qrcode.jpg"
// import emptyImg from "./img/empty.png"
// import {icp} from "./config-local"
import common from "./utils/common";
import EmptyBox from "./components/emptybox";
import NProgress from "./components/nprogress";

// import Section from "./pages/section";
// import Classroom from "./pages/classroom";
// import Home from "./pages/home";
// import Course from "./pages/course";
// import Personal from "./pages/personal";
// import Site from "./pages/site";
// import News from "./pages/news";
// import Opensource from "./pages/opensource";
// import Post from "./pages/post";
// import Passport from "./pages/passport"
// import Register from "./pages/passport/register"
// import Backlog from "./pages/backlog";
// import Card from "./pages/card";
// import CardList from "./pages/card/list";
// import Problem from "./pages/problem";
// import CourseDetail from "./pages/course/CourseDetail.js";

const LearnPathDetail = React.lazy(() => import("./pages/learningPath/detail"));
const Learn = React.lazy(() => import("./pages/learn"));
const Home = React.lazy(() => import("./pages/home"));
const Course = React.lazy(() => import("./pages/course"));
const Personal = React.lazy(() => import("./pages/personal"));
const Profile = React.lazy(() => import("./pages/profile"));
const Message = React.lazy(() => import("./pages/message"));
const Opensource = React.lazy(() => import("./pages/opensource"));
const Post = React.lazy(() => import("./pages/post"));
const Passport = React.lazy(() => import("./pages/passport"));
// const Register = React.lazy(() => import("./pages/passport/register"));
const Backlog = React.lazy(() => import("./pages/backlog"));
const Card = React.lazy(() => import("./pages/card"));
const Coursework = React.lazy(() => import("./pages/coursework"));
const CardList = React.lazy(() => import("./pages/card/list"));
const CardReview = React.lazy(() => import("./pages/card/review"));
const Problem = React.lazy(() => import("./pages/problem"));
const CourseDetail = React.lazy(() => import("./pages/course/CourseDetail"));
const Contest = React.lazy(() => import("./pages/contest"));
const Download = React.lazy(() => import("./pages/download"));
const Question = React.lazy(() => import("./pages/question"));
const QuestionDetail = React.lazy(() => import("./pages/questionDetail"));
const Tools = React.lazy(() => import("./pages/tools"));
const Clipboard = React.lazy(() => import("./pages/clipboard"));
const ClipboardShare = React.lazy(() => import("./pages/clipboard/share"));
const Editor = React.lazy(() => import("./pages/editor"));


const {Header, Content, Footer} = Layout;


function App(props) {

    let [isLogin, setIsLogin] = useState(false)
    // let [notify, setNotify] = useState({})  //新消息通知是否提示
    // let [notifyPage, setNotifyPage] = useState({})  //新消息通知分页数据

    // useEffect(() => {
    //     // 初始化
    // }, [props.location.pathname])
    // }, [])

    // useEffect(() => {
    //     // getNotify()   // 新消息通知
    //     // getNotifyList()   // 新消息通知列表
    //
    // }, [])

    // // 新消息通知
    // let getNotify = () => {
    //     common.ajax('get', '/api/message/notify').then((res) => {
    //         setNotify(res)
    //     })
    // }
    //
    // // 新消息通知列表
    // let getNotifyList = () => {
    //     common.ajax('get', '/api/message').then((res) => {
    //         // console.log(res)
    //         setNotifyPage(res.page)
    //     })
    // }


    // 	注销token
    let logout = () => {
        common.loadingStart()
        common.ajax('post', '/api/user/logout').then((res) => {
            common.setToken(null)
            props.clearUser()
            common.message.success('退出成功')
            props.history.push('/')
        }).finally(common.loadingStop)
    }

    useEffect(() => {
        setIsLogin(props.user.nickname !== '')
    }, [props.user])

    // // 通知内容
    // const noticeContent = (
    //     <Menu className="notice-content-drop-down">
    //         {notify ? (
    //             <Menu.Item
    //                 className="notice-drop-down-item"
    //                 onClick={() => {
    //                     props.history.push("/news")
    //                 }}>
    //
    //                 <div className="item-font" rel="noopener noreferrer">
    //                     新消息通知
    //                     <Space>
    //                         <Badge className="item-font-badge"
    //                                size={'default'} count={2}/>
    //                     </Space>
    //                 </div>
    //             </Menu.Item>
    //         ) : <EmptyBox/>}
    //     </Menu>
    // );

    // // 个人头像下拉列表
    // let avatarContent = (
    //     <Menu className="avatar-content-drop-down">
    //         <div className="avatar-item">
    //             <Button className="avatar-item-button"
    //                     shape={'round'} size={'large'}
    //                     onClick={() => {
    //                         props.history.push('/personal')
    //                     }}>我的主页</Button>
    //         </div>
    //
    //         <div className="avatar-item">
    //             <Button className="avatar-item-button"
    //                     shape={'round'} size={'large'}
    //                     onClick={() => {
    //                         props.history.push('/site')
    //                     }}>个人设置</Button>
    //         </div>
    //         <div className="avatar-item">
    //             <Button className="avatar-item-button-quit"
    //                     type="link"
    //                     onClick={logout}>退出登录</Button>
    //         </div>
    //     </Menu>
    // )

    return (
        <Layout className={'layout-body-box'}>
            <Header className="page-header js-top-header" style={{backgroundColor: '#fff'}}>
                <div className="page-header-div">
                    <Link to={'/'} className="page-header-div-link">
                        <img
                            className="link-img"
                            src={props.tenant.logo ? props.tenant.logo : require('./img/logo.png')}/>

                        {(props.tenant.slogan == null || props.tenant.slogan.length === 0) ? '' :
                            <span
                                className={'slogan'}>{props.tenant.slogan}</span>}
                    </Link>

                    <div className={'mine-div'}>


                        <div className="top-button-div">

                            {/*<div className="top-button-list">*/}
                            {/*   <Link to={'/'} className="top-button">首页</Link>*/}
                            {/*</div>*/}

                            <div className="top-button-list">
                                <Link to={'/'}
                                      className={"top-button " + (window.location.pathname === '/' ? 'active' : '')}>首页</Link>
                            </div>

                            {common.isDaimaku(props.tenant) ? <>


                                    {/*<div className="top-button-list">*/}
                                    {/*    <Link to={'/opensource'} className="top-button">开源</Link>*/}
                                    {/*</div>*/}
                                    <div className="top-button-list">
                                        <Link to={'/tools'}
                                              className={"top-button " + (window.location.pathname === '/tools' ? 'active' : '')}>工具</Link>
                                    </div>

                                    <div className="top-button-list">
                                        <Link to={'/post'}
                                              className={"top-button " + (window.location.pathname.startsWith('/post') ? 'active' : '')}>交流</Link>
                                    </div>

                                    <div className="top-button-list">
                                        <a href={'/oj/'}
                                           target={'_blank'}
                                           className="top-button">题库</a>
                                    </div>


                                    {/*
                                    {isLogin ? (<>
                                        <div className="top-button-list">
                                            <a className="top-button" onClick={() => {
                                                common.alert(<img style={{marginLeft: 16}}
                                                                  src={common.getApiUrl("/api/attendance/qrcode")}></img>, () => {

                                                    // props.history.push('backlog')
                                                }, "请用微信扫码打卡")
                                            }}>签到</a>
                                        </div>
                                    </>) : <></>}
                                    */}

                                </>
                                : ''}
                        </div>

                        {isLogin ? (<>

                                <div className="mine-select-div">
                                    {/*
                                <Dropdown overlay={mineContent} placement="bottomCenter">
                                    <Link to={'#'} className="ant-dropdown-link">
                                        我的课程 <DownOutlined className="icon"/>
                                    </Link>
                                </Dropdown>*/}

                                    <Button type="primary" size={'large'} shape="round"
                                            onClick={() => {
                                                props.history.push('/course')
                                            }}>
                                        我的
                                    </Button>

                                </div>

                                <div className="mine-content">
                                    {/**/}
                                    <div className="mine-notice">
                                        {/*//notify ? (*/}
                                        <Link to={'/message'}>
                                            <Badge className="mine-notice-badge"
                                                   count={props.user.unread}
                                                // size={'small'}
                                                // offset={[-10, 2]}
                                            >
                                                <BellOutlined className="icon"/>
                                            </Badge>
                                        </Link>
                                        {/*//) : (<BellOutlined className="icon"/>)}*/}

                                    </div>


                                    <div className="mine-header-img">
                                        <Avatar size={40} src={props.user.avatar_url}/>
                                        <div className="drop-down-div">
                                            <div className="arrow"></div>
                                            <div className="drop-down-content">
                                                <div className="avatar-item">
                                                    <Button className="avatar-item-button"
                                                            shape={'round'} size={'large'}
                                                            onClick={() => {
                                                                props.history.push('/personal')
                                                            }}>个人中心</Button>
                                                </div>
                                                {/*
                                                <div className="avatar-item">
                                                    <Button className="avatar-item-button"
                                                            shape={'round'} size={'large'}
                                                            onClick={() => {
                                                                props.history.push('/site')
                                                            }}>个人设置</Button>
                                                </div>*/}
                                                <div className="avatar-item">
                                                    <Button className="avatar-item-button-quit"
                                                            type="link"
                                                            onClick={logout}>退出登录</Button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </>)
                            :
                            <>
                                {window.location.href.indexOf('/login') !== -1 ? '' : // 已经在登录页，不显示这个按扭
                                    <div className={'goLogin'}>
                                        <Button className="go-login"
                                                type="link"
                                                size={'large'}
                                                onClick={() => {
                                                    props.history.push('/login?type=1')
                                                }}>登录</Button>
                                        <Button className="go-login"
                                                type="primary"
                                                size={'large'}
                                                onClick={() => {
                                                    props.history.push('/login?type=2')
                                                }}>注册</Button>
                                    </div>}
                            </>}

                    </div>
                </div>
            </Header>
            <Layout className={'app-layout-main'}>
                <Content>
                    <Suspense fallback={<NProgress></NProgress>}>
                        <Switch>
                            <Route exact path={'/'} component={Home}></Route>
                            <Route path={'/login'} component={Passport}/>
                            {/*<Route path={'/register'} component={Register}/>*/}
                            <Route path={'/post'} component={Post}></Route>
                            <Route path={'/learning-path/:id'} component={LearnPathDetail}></Route>
                            <Route exact path={'/learn/:id'} component={Learn}></Route>
                            <Route exact path={'/learn/:id/:chapterId'} component={Learn}></Route>
                            <Route path={'/message'} component={Message}></Route>
                            <Route path={'/course/:id'} component={CourseDetail}></Route>
                            <Route path={'/course'} component={Course}></Route>
                            <Route path={'/backlog'} component={Backlog}></Route>
                            <Route path={'/cardReview'} component={CardReview}></Route>
                            <Route path={'/card/:courseId'} component={Card}></Route>
                            <Route path={'/coursework/:courseId'} component={Coursework}></Route>
                            <Route path={'/cardList'} component={CardList}></Route>
                            <Route path={'/personal'} component={Personal}></Route>
                            <Route path={'/profile'} component={Profile}></Route>
                            <Route path={'/opensource'} component={Opensource}></Route>
                            <Route exact path={'/problem/:id'} component={Problem}></Route>
                            <Route path={'/contest/:id'} component={Contest}></Route>
                            <Route path={'/download'} component={Download}></Route>
                            <Route exact path={'/question'} component={Question}></Route>
                            <Route path={'/question/:id'} component={QuestionDetail}></Route>
                            <Route exact path={'/clipboard/:share'} component={ClipboardShare}></Route>
                            <Route exact path={'/clipboard'} component={Clipboard}></Route>
                            <Route exact path={'/tools'} component={Tools}></Route>
                            <Route exact path={'/editor'} component={Editor}></Route>

                            <Route path="*">
                                <div style={{padding: "100px 0", textAlign: "center", fontSize: 18}}>
                                    404 Not Found
                                </div>
                            </Route>
                        </Switch>
                    </Suspense>
                </Content>
            </Layout>
            <Footer className="footer-box">

                {common.isDaimaku(props.tenant) ?
                    <div className="footer-content">
                        <div className="footer-left-div">
                            <div className="img-div">
                                <img className="img"
                                     src={require('./img/qrcode.jpg')}
                                     alt=""/>
                            </div>
                            {/*<div className="icon-div">
                            <Dropdown overlay={WeChatQRCode} placement="topCenter" arrow>
                                <div className="icon-img-div">
                                    <img className="icon-img"
                                         src={wechatImg} alt=""/>
                                </div>
                            </Dropdown>
                        </div>*/}
                        </div>

                        <div className="footer-content-list">
                            <div className="footer-content-list-title">公司</div>
                            <div className="footer-content-list-content">
                                <Link to={'#'} className="list-font">关于我们</Link>
                            </div>
                            <div className="footer-content-list-content">
                                <Link to={'#'} className="list-font">联系我们</Link>
                            </div>
                            <div className="footer-content-list-content">
                                <Link to={'#'} className="list-font">加入我们</Link>
                            </div>
                        </div>
                        <div className="footer-content-list">
                            <div className="footer-content-list-title">产品与服务</div>
                            <div className="footer-content-list-content">
                                <Link to={'#'} className="list-font">会员服务</Link>
                            </div>
                            <div className="footer-content-list-content">
                                <Link to={'#'} className="list-font">实战训练营</Link>
                            </div>
                            <div className="footer-content-list-content">
                                <Link to={'#'} className="list-font">就业班</Link>
                            </div>
                            <div className="footer-content-list-content">
                                <Link to={'#'} className="list-font">保入职</Link>
                            </div>
                        </div>
                        <div className="footer-content-list">
                            <div className="footer-content-list-title">合作</div>
                            <div className="footer-content-list-content">
                                <Link to={'#'} className="list-font">1+X证书</Link>
                            </div>
                            <div className="footer-content-list-content">
                                <Link to={'#'} className="list-font">高校实验教学</Link>
                            </div>
                            <div className="footer-content-list-content">
                                <Link to={'#'} className="list-font">企业内训</Link>
                            </div>
                            <div className="footer-content-list-content">
                                <Link to={'#'} className="list-font">合办学院</Link>
                            </div>
                            <div className="footer-content-list-content">
                                <Link to={'#'} className="list-font">成为作者</Link>
                            </div>
                        </div>
                        <div className="footer-content-list">
                            <div className="footer-content-list-title">学习路径</div>
                            <div className="footer-content-list-content">
                                <Link to={'#'} className="list-font">Python学习路径</Link>
                            </div>
                            <div className="footer-content-list-content">
                                <Link to={'#'} className="list-font">Linux学习路径</Link>
                            </div>
                            <div className="footer-content-list-content">
                                <Link to={'#'} className="list-font">大数据学习路径</Link>
                            </div>
                            <div className="footer-content-list-content">
                                <Link to={'#'} className="list-font">Java学习路径</Link>
                            </div>
                            <div className="footer-content-list-content">
                                <Link to={'#'} className="list-font">PHP学习路径</Link>
                            </div>
                            <div className="footer-content-list-content">
                                <Link to={'#'} className="list-font">全部</Link>
                            </div>
                        </div>
                    </div> : ''}

                <div className="copy-div">
                    <span>Copyright 2020-{new Date().getFullYear()} © {props.tenant.copyright}
                        <a className="copy-div-font"
                           href="https://beian.miit.gov.cn" target={'_blank'}>
                      {props.tenant.icp}
                    </a> {props.tenant.company}
                    </span>

                </div>
            </Footer>
        </Layout>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
        tenant: state.tenant
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        clearUser: () => {
            dispatch({type: 'CLEAR_USER'})
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(App)
